import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';
import LegalText from '@components/LegalText';
import { LEGAL_TEXT_TYPES } from '../../../constants/legalText.const';

const CookiePolicy = () => {
  return (
    <>
      <Header />
      <main>
        <div className="container py-5 mt-5">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <div className="text-center mb-4">
                <h1 className="fw-bold">Çevrimiçi Gizlilik İlkesi</h1>
                <p className="text-muted mb-0">Mayıs 2026'da güncellendi</p>
              </div>
              <div className="card shadow-sm border-0">
                <div className="card-body p-4 cookie-policy">
                  <LegalText
                    type={LEGAL_TEXT_TYPES.CEREZ_POLITIKASI}
                    className=""
                  />

                  <div className="text-center mt-4">
                    <Link to="/" className="btn btn-blue py-2 px-4 rounded-3">
                      Ana Sayfaya Dön
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default CookiePolicy;
